import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=6c58d946&"
import script from "./LoginComponent.vue?vue&type=script&lang=js&"
export * from "./LoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginComponent.vue?vue&type=style&index=0&id=6c58d946&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports